import actionType from "./actionTypes";
import initialState from "./initialState";


const patientReducer = (state = initialState, action) => {
  switch (action.type) {

    case actionType.PAYMENT_ADD_NAV_NULL:
    return {
      ...state,
      paymentMethodNotAddedStatus : false 
      
    };
    case actionType.PAYMENT_NOT_ADDED:
    return {
      ...state,
      paymentMethodNotAddedStatus : true
      
    };
    
    case actionType.AGREEPAY_NULL:
    return {
      ...state,
      isAutoPayStatus : false
      
    };

    case actionType.INITIAL_STATUS_NULLIFY:
    return {
      ...state,
      isAutoPayStatus :false,
      enableAccountstatus: false,
      disbaleAccountstatus:false,
      verifyOtpEnableAccStatus:false,
      
    };

    case actionType.VERIFY_OTP_ENABLE_ACCOUNT_SUCCESS:
    return {
      ...state,
      verifyOtpEnableAccStatus: true,
      
    };
  case actionType.VERIFY_OTP_ENABLE_ACCOUNT_FAILURE:
    return {
      ...state,
      verifyOtpEnableAccStatus: false,
    };
    case actionType.ENABLE_ACCOUNT_SUCCESS:
    return {
      ...state,
      verifyOtpEnableAccStatus:false,
      enableAccountstatus: true,
      
    };
  case actionType.ENABLE_ACCOUNT_FAILURE:
    return {
      ...state,
      enableAccountstatus: false,
    };

    case actionType.DISABLE_ACCOUNT_SUCCESS:
    return {
      ...state,
      disbaleAccountstatus: true,
      
    };
  case actionType.DISABLE_ACCOUNT_FAILURE:
    return {
      ...state,
      disbaleAccountstatus: false,
    };

    case actionType.GET_OTHER_CLASSIFICATIONS_SUCCESS:
      return {
        ...state,
        getOtherClassificationsStatus: true,
        getOtherClassificationsDetails: action.payload
      };
    case actionType.GET_OTHER_CLASSIFICATIONS_FAILURE:
      return {
        ...state,
        getOtherClassificationsStatus: false,
      };

    case actionType.DOWNLOAD_RECORDS_SUCCESS:
      return {
        ...state,
        downloadRecordService: true,
        downloadRecordDetails: action.payload
      };
    case actionType.DOWNLOAD_RECORDS_FAILURE:
      return {
        ...state,
        downloadRecordService: false,
      };



    case actionType.COST_AGREE_SUCCESS:
      return {
        ...state,
        isCostAgree: true,
        isAutoPayStatus: false
      };
    case actionType.COST_AGREE_FAILURE:
      return {
        ...state,
        isCostAgree: false
      };

    case actionType.IS_AUTO_PAY_SUCCESS:
      return {
        ...state,
        getApiCostDetails: action.payload,
        isAutoPayStatus: true,
      };
    case actionType.IS_AUTO_PAY_FAILURE:
      return {
        ...state,
        message: action.message,
        isAutoPayStatus: false
      };


    case actionType.IS_DEFAULT_CARD_SUCCESS:
      return {
        ...state,
        isDefaultCardStatus: true,
      };
    case actionType.IS_DEFAULT_CARD_FAILURE:
      return {
        ...state,
        isDefaultCardStatus: false
      };


    case actionType.GET_PAYMENT_METHODS_SUCCESS:
      return {
        ...state,
        isAutoPayStatus : false,
        addPaymentSuccessStatus: false,
        getPaymentMethodsList: action.payload,
        getPaymentMethodsListStatus: true,
        message: action.message
      };
    case actionType.GET_PAYMENT_METHODS_FAILURE:
      return {
        ...state,
        isAutoPayStatus : false,
        message: action.message,
        getPaymentMethodsListStatus: false,
        getPaymentMethodsList: { paymentMethodInfoList: [] }
      };

    case actionType.ADD_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        addPaymentSuccessStatus: true,
        message: action.message
      };
    case actionType.ADD_PAYMENT_METHOD_FAILURE:
      return {
        ...state,
        message: action.message,
        addPaymentSuccessStatus: false
      };

    case actionType.GET_APP_COST_SUCCESS:
      return {
        ...state,
        isAutoPayStatus:false,
        getApiCostStatus: true,
        getApiCostDetails: action.payload,

        id:action.typeId,
        list:action.pList,
        requestDetailsforFinalRequest: action.requestData,
        recordDetails: action.recordDetails,
        message: action.message,
        isCostAgree: false
      };
    case actionType.GET_APP_COST_FAILURE:
      return {
        ...state,
        message: action.message,
        getApiCostStatus: false
      };

    case actionType.GET_FACILITY_ADDRESS_SUCCESS:
      return {
        ...state,
        getSelectedFacilityDetails: action.data,
        getFacilityAddressStatus: true,
        getFacilityAddress: action.payload,
        message: action.message
      };
    case actionType.GET_FACILITY_ADDRESS_FAILURE:
      return {
        ...state,
        message: action.message,
        getFacilityAddressStatus: false
      };

    case actionType.GET_AUTH_EXP_LIST_SUCCESS:
      return {
        ...state,
        getAuthExpStatus: true,
        getAuthExpListDetails: action.payload,
        message: action.message
      };
    case actionType.GET_AUTH_EXP_LIST_FAILURE:
      return {
        ...state,
        message: action.message,
        getAuthExpStatus: false
      };

    case actionType.GET_RESPONSE_TIME_LIST_SUCCESS:
      return {
        ...state,
        getResponseTimeStatus: true,
        getResponseTimeListDetails: action.payload,
        message: action.message
      };
    case actionType.GET_RESPONSE_LIST_TIME_FAILURE:
      return {
        ...state,
        message: action.message,
        getResponseTimeStatus: false
      };

    case actionType.GET_RECORDS_LIST_SUCCESS:
      return {
        ...state,
        getApiCostStatus: false,
        downloadRecordService: false,
        getRecordsListStatus: true,
        getFacilityAddressStatus: false,
        getRecordsListDetails: action.payload,
        message: action.message
      };
    case actionType.GET_RECORDS_LIST_FAILURE:
      return {
        ...state,
        message: action.message,
        downloadRecordService: false,
        getRecordsListStatus: false
      };

    case actionType.NEW_FACILITY_REQUEST_SUCCESS:
      return {
        ...state,
        newFacilityStatus: true,
        message: action.message
      };
    case actionType.NEW_FACILITY_REQUEST_FAILURE:
      return {
        ...state,
        message: action.message,
        newFacilityStatus: false
      };
    case actionType.PATIENT_REGISTER_SUCCESS:
      return {
        ...state,
        PatientRegisterDetails: action.payload,
        PatientRegisterStatus: true,
        message: action.message
      };
    case actionType.PATIENT_REGISTER_FAILURE:
      return {
        ...state,
        message: action.message,
        PatientRegisterStatus: false
      };

    case actionType.PATIENT_REQUEST_INFO_SUCCESS:
      return {
        ...state,
        downloadRecordService: false,
        PatientReqInfoStatus: true,
        PatientReqInfoList: action.payload,
      }
    case actionType.PATIENT_REQUEST_INFO_FAILURE:
      return {
        ...state,
        downloadRecordService: false,
        PatientReqInfoStatus: false,

      }

    case actionType.GET_BY_PRACTICE_SUCCESS:
      return {
        ...state,
        facilityListStatus: false,
        searchByAllStatus: false,
        getByPracticeDetails: action.payload,
        getByPracticeStatus: true,
        message: action.message
      };
    case actionType.GET_BY_PRACTICE_FAILURE:
      return {
        ...state,
        message: action.message,
        getByPracticeStatus: false
      };

    case actionType.GET_BY_DOCTOR_SUCCESS:
      return {
        ...state,
        getByDoctorDetails: action.payload,
        getByDoctorStatus: true,
        message: action.message
      };
    case actionType.GET_BY_DOCTOR_FAILURE:
      return {
        ...state,
        message: action.message,
        getByDoctorStatus: false
      };

    case actionType.GET_BY_LOCATION_SUCCESS:
      return {
        ...state,

        getByLocationDetails: action.payload,
        getByLocationStatus: true,
        message: action.message
      };
    case actionType.GET_BY_LOCATION_FAILURE:
      return {
        ...state,
        message: action.message,
        getByLocationStatus: false
      };


    case actionType.SEARCH_BY_ALL_SUCCESS:
      return {
        ...state,
        searchByAllDetails: action.payload,
        searchByAllStatus: true,
        message: action.message
      };
    case actionType.SEARCH_BY_ALL_FAILURE:
      return {
        ...state,
        searchByAllStatus: false,
        searchByAllDetails: {
          finalSearchDetails: []
        }
      };

    case actionType.FACILITY_LIST_SUCCESS:
      return {
        ...state,
        facilityListStatus: true,
        facilityListDetails: action.payload,
        message: action.message
      };
    case actionType.FACILITY_LIST_FAILURE:
      return {
        ...state,
        message: action.message,
        facilityListStatus: false
      };
    case actionType.MAKE_NEW_FACILITY_REQUEST:
      return {
        ...state,
        newFacilityStatus: false,
      };
    case actionType.MAKE_PATIENT_REGISTER_STATUS:
      return {
        ...state,
        PatientRegisterStatus: false,
      };
    case actionType.VALIDATE_FEDEX_AVAIL_FAILURE:
      return {
        ...state,
        getApiCostStatus: false,
      }

    default:
      return state;
  }
};
export default patientReducer;
